import { Fragment } from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { FieldArrayPath, useFieldArray, useFormState } from 'react-hook-form';

import { PublicPackage } from '@drivingdoc/api-client/generated/types';

import { RegistrationFormOutputValues } from '../utils/validationSchema';
import SectionList from './SectionList';

interface PropTypes {
  name: FieldArrayPath<RegistrationFormOutputValues>;
  courses: PublicPackage['courses'];
}

function SelectSectionFieldArray({ name, courses }: PropTypes) {
  const fieldArray = useFieldArray({ name: name });
  const { errors } = useFormState<RegistrationFormOutputValues>({
    name: name,
  });

  return (
    <Grid container rowSpacing={2}>
      <Grid size={12}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 'bold',
            textDecoration: 'underline',
          }}
        >
          Select Course Sections
        </Typography>
      </Grid>

      {fieldArray.fields.map((_field, index) => {
        const course = courses?.[index];
        if (course?.sections?.length === 0) {
          return (
            <Grid size={12} key={index}>
              <Typography variant="h6">{course.title}</Typography>
              <Typography variant="h5" color="error" align="center">
                No sections available for &quot;{course.title}&quot;. Please check back later.
              </Typography>
            </Grid>
          );
        }

        return (
          <Fragment key={index}>
            <Grid size={12}>
              <Typography variant="h6">{course.title}</Typography>
              <Typography color="error" fontWeight="bold">
                {(errors[name]?.[index] as { section_id?: { message?: string } })?.section_id?.message}
              </Typography>
            </Grid>

            <Grid size={12} key={course.id} mb={8}>
              <SectionList name={`courses.${index}.section_id`} sections={course?.sections} />
            </Grid>
          </Fragment>
        );
      })}

      {fieldArray.fields.length === 0 && (
        <Grid size={12} mt={2}>
          <Typography variant="h5" color="error" align="center">
            No Courses In Package
          </Typography>
        </Grid>
      )}
    </Grid>
  );
}

export default SelectSectionFieldArray;
